import type { CsnSearchVenue } from '@/models/CsnSearchVenue';
import { CSN_AD_VIEW_FACT_TYPE, getPageUrl, PRODUCT, SEARCH_RESULTS_PAGE } from '@/utils/analyticsClientHelper';
import type { AdViewFact } from '@/analytics/models/cventAnalytics/AdViewFact';

export type AdInfo = {
  venue_id: string | undefined;
  code: string | undefined;
  ad_id: string | undefined;
  ad_type: string | undefined;
  position: number;
};

const OFFSET = 1;

function getAdInfo(venue: CsnSearchVenue, position: number): AdInfo {
  return {
    venue_id: venue.id,
    code: venue.code,
    ad_id: venue.listingCode,
    ad_type: venue.featuredLevel,
    position: position + OFFSET
  };
}

function handleNullAds(ads: AdInfo[]): string {
  return JSON.stringify(
    Object.keys(ads).map(key => {
      if (ads[key].length === 0) {
        return null;
      }
      return ads[key];
    })
  );
}

// Returns the Impressions for ads
export default function getAdViewFact(
  searchTerm: string,
  rfpId: string | undefined,
  venuesList: CsnSearchVenue[],
  isMapExpanded: boolean,
  source: string,
  adType: string
): AdViewFact {
  const adsList: AdInfo[] = [];
  venuesList.forEach(venue => {
    adsList.push(getAdInfo(venue, adsList.length));
  });

  return {
    type: CSN_AD_VIEW_FACT_TYPE,
    page: SEARCH_RESULTS_PAGE,
    product: PRODUCT,
    rfp_id: rfpId ?? 'null',
    search_term: searchTerm,
    ad_type: adType,
    ads: handleNullAds(adsList),
    map_view: isMapExpanded ? 'EXPANDED' : 'COLLAPSED',
    page_url: getPageUrl(),
    source
  };
}
